import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, Briefcase, MapPin, Clock } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Careers = () => {
  const { isArabic } = useLanguage();

  const jobs = [
    {
      id: 1,
      title: isArabic ? "مدير فرع (مخبز)" : "Branch Manager (Bakery)",
      type: isArabic ? "دوام كامل" : "Full-time",
      location: isArabic ? "الرياض" : "Riyadh",
    },
    {
      id: 2,
      title: isArabic ? "مشرف جودة أغذية" : "Food Quality Supervisor",
      type: isArabic ? "دوام كامل" : "Full-time",
      location: isArabic ? "الخبر" : "Al Khobar",
    },
    {
      id: 3,
      title: isArabic ? "محاسب مالي" : "Sales Person",
      type: isArabic ? "دوام كامل" : "Full-time",
      location: isArabic ? "الرياض" : "Riyadh",
    },
  ];

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-6">
      <div className="max-w-4xl mx-auto bg-white rounded-[3rem] shadow-2xl overflow-hidden border border-slate-100">
        
        {/* Banner Section */}
        <div className="bg-corp-blue p-12 text-center text-white relative">
          <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]"></div>
          <div className="relative z-10">
            <div className="w-20 h-20 bg-saudi-green rounded-3xl flex items-center justify-center mx-auto mb-6 rotate-3 shadow-xl">
              <Briefcase size={40} className="text-white" />
            </div>
            <h1 className="text-4xl font-bold mb-2">
              {isArabic ? "بناء المستقبل مع أقام" : "Build the Future with AFAM"}
            </h1>
            <p className="text-saudi-green font-medium tracking-widest uppercase text-sm">
              {isArabic ? "فرص وظيفية حقيقية" : "Real Career Opportunities"}
            </p>
          </div>
        </div>

        <div className={`p-8 md:p-12 ${isArabic ? 'text-right' : 'text-left'}`}>
          {/* Intro Notice */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold text-corp-blue mb-4">
              {isArabic ? "لماذا تنضم إلينا؟" : "Why Join Us?"}
            </h2>
            <p className="text-gray-600 leading-relaxed">
              {isArabic 
                ? "في مجموعة أقام، نحن نؤمن بأن موظفينا هم سر نجاحنا. نحن نوفر بيئة عمل محفزة تدعم الابتكار والتميز في قطاع التجزئة السعودي."
                : "At AFAM Group, we believe our people are our greatest asset. We provide a stimulating work environment that supports innovation and excellence in the Saudi retail sector."}
            </p>
          </div>

          {/* Jobs Table */}
          <h3 className="text-xl font-bold text-corp-blue mb-6 border-b pb-4 border-slate-100">
            {isArabic ? "الوظائف الشاغرة حالياً" : "Current Openings"}
          </h3>
          
          <div className="space-y-4 mb-12">
            {jobs.map((job) => (
              <div 
                key={job.id} 
                className={`p-6 rounded-2xl bg-slate-50 border border-transparent hover:border-saudi-green hover:bg-white hover:shadow-lg transition-all flex flex-col md:flex-row justify-between items-center gap-4 ${isArabic ? 'md:flex-row-reverse' : ''}`}
              >
                <div>
                  <h4 className="text-lg font-bold text-corp-blue">{job.title}</h4>
                  <div className={`flex items-center gap-4 mt-2 text-sm text-gray-500 ${isArabic ? 'flex-row-reverse' : ''}`}>
                    <span className="flex items-center gap-1"><MapPin size={14}/> {job.location}</span>
                    <span className="flex items-center gap-1"><Clock size={14}/> {job.type}</span>
                  </div>
                </div>
                <div className={`bg-saudi-green/10 text-saudi-green px-4 py-2 rounded-full text-sm font-bold`}>
                  {isArabic ? "متاح" : "Open"}
                </div>
              </div>
            ))}
          </div>

          {/* Contact Footer */}
          <div className="bg-corp-blue rounded-3xl p-8 text-center text-white">
            <h4 className="text-xl font-bold mb-2">{isArabic ? "كيفية التقديم" : "How to Apply"}</h4>
            <p className="text-gray-300 mb-6">
              {isArabic 
                ? "يرجى إرسال سيرتك الذاتية مع ذكر المسمى الوظيفي في الموضوع" 
                : "Please send your CV and mention the job title in the subject line"}
            </p>
            <div className="flex items-center justify-center gap-2 bg-white/10 py-3 px-6 rounded-xl border border-white/20 w-fit mx-auto">
              <Mail size={18} className="text-saudi-green" />
              <span className="font-bold">careers@afam.com.sa</span>
            </div>
          </div>

          <div className="mt-10">
            <Link 
              to="/" 
              className={`flex items-center gap-2 font-bold text-corp-blue hover:text-saudi-green transition-colors ${isArabic ? 'flex-row-reverse' : ''}`}
            >
              <ArrowLeft size={20} className={isArabic ? 'rotate-180' : ''} />
              {isArabic ? "العودة للرئيسية" : "Back to Home"}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Careers;